import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function diffDays(date) {
  if (date != null) {
    let now = new Date() // Data de hoje

    // data passada por parametro
    let dataSplit = date.split('-')
    let day = dataSplit[2]
    let month = dataSplit[1]
    let year = dataSplit[0]
    let date1 = new Date(year, month - 1, day)

    let timeDiff = Math.abs(now.getTime() - date1.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    return parseInt(diffDays)
  }
}

export function generatePdf(
  cadastros,
  selectEquipe,
  nomeProfissional,
  data_secretaria_de_saude
) {
  let title_pdf = 'Famílias visitadas'
  let titlePdfSave = utils.methods.titlePdf(
    'Famílias visitadas',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Última visita realizada em algum membro da família'
  let headers_pdf = [
    'RESPONSÁVEL FAMILIAR',
    'DATA DE NASCIMENTO',
    'IDADE',
    'VISITADO',
    'DIAS',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.idade = cadastros[i].idade
    obj.dt_ultima_visita = utils.methods.formatDate(
      cadastros[i].dt_ultima_visita
    )
    obj.dias = diffDays(cadastros[i].dt_ultima_visita)
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )
      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section !== 'head') {
            if (data.row.raw[3] != undefined) {
              let dt_ultima_visita = data.row.raw[3]
                .split('/')
                .reverse()
                .join('-')
              let diff = utils.methods.differenceOfDaysBetweenTwoDates(
                dt_ultima_visita,
                data_secretaria_de_saude
              )
              if (diff > 30 || dt_ultima_visita == undefined) {
                doc.setTextColor(194, 10, 16)
              } else {
                doc.setTextColor(2, 99, 57)
              }
            } else {
              doc.setTextColor(194, 10, 16)
            }
          }

          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
/* Retorna a diferença de dias entre a data atual e a data passada como parâmetro */
function diffDates(date, data_secretaria_de_saude) {
  if (date !== null) {
    // let now = new Date(); // Data de hoje

    // data passada por parametro
    let dataSplit = date.split('-')
    let day = dataSplit[2]
    let month = dataSplit[1]
    let year = dataSplit[0]
    let date1 = new Date(year, month - 1, day)

    // data da última atualização
    let dataUltimaAtualizacao = data_secretaria_de_saude
    let dataSplitUltimaAtualizacao = dataUltimaAtualizacao.split('/')
    let date2 = new Date(
      dataSplitUltimaAtualizacao[2] +
        '/' +
        dataSplitUltimaAtualizacao[1] +
        '/' +
        dataSplitUltimaAtualizacao[0]
    )

    let timeDiff = Math.abs(date2.getTime() - date1.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    // console.log(date1);
    return diffDays
  } else {
    return '+157'
  }
}
export function exibirVermelhos(cadastros, data_secretaria_de_saude) {
  let filtro = cadastros.filter((item) => {
    let diff = diffDates(item.dt_ultima_visita, data_secretaria_de_saude)
    if (diff > 30 || item.dt_ultima_visita == null) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function exibirVerdes(cadastros, data_secretaria_de_saude) {
  let filtro = cadastros.filter((item) => {
    let diff = diffDates(item.dt_ultima_visita, data_secretaria_de_saude)
    if (diff > 30 || item.dt_ultima_visita == null) {
      return false
    } else {
      return true
    }
  })

  return filtro
}
export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Idade: 'idade',
  Visitado: {
    field: 'dt_ultima_visita',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Dias: {
    field: 'dt_ultima_visita',
    callback: (value) => {
      return value !== ''
        ? diffDates(
            value,
            store.state.ultimaAtualizacao !== null
              ? store.state.ultimaAtualizacao
              : ''
          )
        : ''
    },
  },
}
